const PREFIX = 'ADVERTISEMENT'

export const ADVERTISEMENT_GET = `${PREFIX}_GET`
export const ADVERTISEMENT_CLEAR = `${PREFIX}_CLEAR`
export const ADVERTISEMENT_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`